import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ScheduleCard from './schedule-card';
import { addNewHotelSaleItem } from '../../hooks/use-get-default-values';
import { HotelPurchaseFormType } from '../form-type';

function ScheduleSectionComponent() {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext<HotelPurchaseFormType>();
  const { append, remove } = useFieldArray({
    control,
    name: 'hotelPurchases',
    keyName: '__customId',
  });
  const onAdd = () => append(addNewHotelSaleItem());

  const onRemove = React.useCallback((index) => remove(index), [remove]);
  const { editable } = useFormState();

  const hotelPurchases = getValues('hotelPurchases');

  return (
    <div>
      {(hotelPurchases || []).map((hotelPurchase, idx) => (
        <React.Fragment key={hotelPurchase.customId}>
          <ScheduleCard
            parentIndex={idx}
            onRemove={() => onRemove(idx)}
            fieldLength={hotelPurchases.length}
          />
          <SeparatorVertical $margin={20}>
            <div style={{ height: 1, width: 4 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('ticketOrders:schedule') })}
        </Button>
      )}
    </div>
  );
}

export default function ScheduleSection() {
  return <ScheduleSectionComponent />;
}
